<template>
  <v-footer>
    <v-btn text rounded router :to='{ name: "Contact" }'>
      Contact
    </v-btn>
    <v-btn text rounded router :to='{ name: "Privacy" }'>
      Privacy
    </v-btn>
    <v-spacer></v-spacer>
    <div>&copy; {{ new Date().getFullYear() }}</div>
  </v-footer>
  
</template>

<script>
export default {
  
}
</script>